import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { create, use } from '@/config';
import '@/assets/iconfont/public/iconfont.css';
import 'swiper/dist/css/swiper.css';//这里注意具体看使用的版本是否需要引入样式，以及具体位置，此版本使用@4.5.1。
import '@/styles/css/index.css';
import '@/styles/less/antd.less';
import "ant-design-vue/dist/antd.less";

Vue.config.productionTip = false;

use(Vue);
create(Vue, router);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
